import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const products = ["El Ebook Maestro 'Protocolo Varonil 45+' con el sistema paso a paso.", 'La Rutina OMH de 5 Minutos (Ejercicios que puedes hacer en tu sala o oficina).', "La Guía de 'Fast Food Hacking' para comer sano en la ruta (Walmart, 7-Eleven, Wendy's).", 'El Protocolo de Apagado de Cortisol para eliminar el estrés en 2 minutos.', "El Checklist de Supermercado 'Anti-Estrógenos' para limpiar tu alacena.", 'Plan de Acción de 21 Días para ver resultados reales y medibles.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProductStack() {
  return <section className="py-16 md:py-24 px-6 bg-brand-dark" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-137">
          <h2 className="font-heading font-bold text-4xl md:text-5xl text-brand-text uppercase mb-4" data-id="element-138">
            Lo Que <span className="text-brand-accent" data-id="element-139">Recibes</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="bg-brand-surface rounded-2xl p-6 md:p-10 border border-brand-card shadow-xl" data-id="element-140">
          <ul className="space-y-6" role="list" data-id="element-141">
            {products.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-142">
                <CheckCircle2 className="w-7 h-7 text-brand-accent flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-143" />
                <span className="font-body text-lg text-brand-text leading-relaxed" data-id="element-144">
                  {item}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}